import { findPeople } from '../services/findPeople';
import store from '../store/contactPickerStore';
import ContactPickerStore from '../store/schema/ContactPickerStore';
import processFindPeopleResult from 'owa-recipient-common/lib/actions/processFindPeopleResult';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { action, select } from 'satcheljs/lib/legacy';

const MAX_RESULTS_DEFAULT = 50;
const MAX_RESULTS_SECONDARY_SEARCH = 10;
const STARTING_OFFSET = 0;

export interface ContactPickerState {
    store: ContactPickerStore;
}

export let populateContactPicker = action('populateContactPicker')(
    select<ContactPickerState>({
        store: () => store,
    })(async function populateContactPicker(
        offset: number = STARTING_OFFSET,
        maxResults: number = MAX_RESULTS_DEFAULT,
        displayedContactsOffset: number = 0,
        state?: ContactPickerState
    ) {
        state.store.isLoading = true;
        let findPeopleResult = await findPeople(offset, maxResults);

        let findResultSet: FindRecipientPersonaType[] = [];
        processFindPeopleResult(
            findResultSet,
            findPeopleResult,
            false /*appendResults*/,
            findPeopleResult.ResultSet.length
        );

        state.store.isLoading = false;
        state.store.maxForSession = findPeopleResult.TotalNumberOfPeopleInView;

        state.store.contacts.splice(
            displayedContactsOffset,
            findResultSet.length,
            ...findResultSet
        );

        let newOffset = offset + findPeopleResult.ResultSet.length;

        if (newOffset < state.store.maxForSession) {
            populateContactPicker(
                newOffset,
                Math.min(MAX_RESULTS_SECONDARY_SEARCH, store.maxForSession - newOffset),
                displayedContactsOffset + findResultSet.length,
                state
            );
        }
    })
);

export default populateContactPicker;
